// app/redux/sagas/attestationsSaga.js

import { all, call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    // types
    FETCH_ATTESTATIONS_REQUEST,
    CREATE_ATTESTATION_REQUEST,
    UPDATE_ATTESTATION_REQUEST,
    DELETE_ATTESTATION_REQUEST,

    GET_MY_ATTESTATION_REQUESTS_REQUEST,
    CREATE_ATTESTATION_REQUEST_REQUEST,

    GET_MANAGER_ATTESTATION_INBOX_REQUEST,
    MANAGER_ATTESTATION_DECISION_REQUEST,

    GET_ADMIN_ATTESTATION_INBOX_REQUEST,
    GET_ADMIN_ATTESTATION_HISTORY_REQUEST,
    ADMIN_ATTESTATION_DECISION_REQUEST,

    DOWNLOAD_ATTESTATION_PDF_REQUEST,
    DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST,

    // actions
    setAttestationsLoading,

    fetchAttestationsSuccess,
    fetchAttestationsFail,

    createAttestationSuccess,
    createAttestationFail,

    updateAttestationSuccess,
    updateAttestationFail,

    deleteAttestationSuccess,
    deleteAttestationFail,

    getMyAttestationRequestsSuccess,
    getMyAttestationRequestsFail,

    createAttestationRequestSuccess,
    createAttestationRequestFail,

    getManagerAttestationInboxSuccess,
    getManagerAttestationInboxFail,

    managerAttestationDecisionSuccess,
    managerAttestationDecisionFail,

    getAdminAttestationInboxSuccess,
    getAdminAttestationInboxFail,
    getAdminAttestationHistorySuccess,
    getAdminAttestationHistoryFail,

    adminAttestationDecisionSuccess,
    adminAttestationDecisionFail,

    downloadAttestationPdfSuccess,
    downloadAttestationPdfFail,

    downloadAttestationRequestPdfSuccess,
    downloadAttestationRequestPdfFail,
} from "../actions/attestationsActions";

// ⚠️ adapte le chemin selon ton projet (comme leaveRequestsSaga)
import {API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest, getRequestForPdf} from "../../../api";

const getUidHeader = () => {
    const uid = sessionStorage.getItem("uid");
    return uid ? String(uid) : "";
};

const extractErrorMessage = (error, fallback) => {
    if (error?.response?.data?.message) return String(error.response.data.message);
    if (error?.response?.data?.error) return String(error.response.data.error);
    if (error?.message) return String(error.message);
    return fallback;
};

export function saveBlob(data, filename = "file.pdf") {
    const blob = data instanceof Blob ? data : new Blob([data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
}

// ===================== PARAMETRAGE =====================
export function* fetchAttestationsSaga() {
    const url = `${API_BASE_URL}/api/attestations`;
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");


    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchAttestationsSuccess(resp.data || []));
    } catch (error) {
        yield put(fetchAttestationsFail(extractErrorMessage(error, "Erreur chargement attestations")));
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* createAttestationSaga(action) {
    const token = sessionStorage.getItem("token");
    const url = `${API_BASE_URL}/api/attestations`;
    const data = action.payload;

    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(createAttestationSuccess(resp.data));
        yield put(setAttestationsLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Attestation ajoutée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors de l'ajout");
        yield put(createAttestationFail(msg));
        yield put(setAttestationsLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }
}

export function* updateAttestationSaga(action) {
    const { id, ...payload } = action.payload || {};
    const url = `${API_BASE_URL}/api/attestations/${id}`;
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");


    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(putRequest, { url, token, data: payload, headers: { uid } });
        yield put(updateAttestationSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", title: "", text: "Attestation mise à jour", timer: 1500, showConfirmButton: false });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur mise à jour attestation");
        yield put(updateAttestationFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2000, showConfirmButton: false });
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* deleteAttestationSaga(action) {
    const id = action.payload;
    const url = `${API_BASE_URL}/api/attestations/${id}`;
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");


    yield put(setAttestationsLoading(true));
    try {
        yield call(deleteRequest, { url, token, headers: { uid } });
        yield put(deleteAttestationSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", title: "", text: "Attestation supprimée", timer: 1400, showConfirmButton: false });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur suppression attestation");
        yield put(deleteAttestationFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2000, showConfirmButton: false });
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

// ===================== WORKFLOW DEMANDES =====================
export function* getMyAttestationRequestsSaga() {
    const url = `${API_BASE_URL}/api/attestations/requests/mine`;
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");


    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMyAttestationRequestsSuccess(resp.data || []));
    } catch (error) {
        yield put(getMyAttestationRequestsFail(extractErrorMessage(error, "Erreur chargement demandes attestations")));
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* createAttestationRequestSaga(action) {
    // payload: { attestationId, motif, attachments: File[] }
    const url = `${API_BASE_URL}/api/attestations/requests`;
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");


    const { attestationId, motif, commentaire, dateLimitePreparation, attachments } = action.payload || {};

    // FormData (motif + files[])
    const fd = new FormData();
    fd.append("attestationId", String(attestationId || ""));
    fd.append("motif", motif || "");
    fd.append("commentaire", commentaire || ""); // ✅ new
    if (dateLimitePreparation) {
        fd.append("dateLimitePreparation", dateLimitePreparation); // ✅ "YYYY-MM-DD"
    }
    if (Array.isArray(attachments)) {
        attachments.forEach((f) => {
            if (f) fd.append("attachments", f);
        });
    }

    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: fd,
            headers: { uid, "Content-Type": "multipart/form-data" },
        });

        yield put(createAttestationRequestSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande envoyée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_ATTESTATION_REQUESTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande attestation");
        yield put(createAttestationRequestFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* getManagerAttestationInboxSaga() {
    const url = `${API_BASE_URL}/api/attestations/manager/inbox`;
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");


    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerAttestationInboxSuccess(resp.data || []));
    } catch (error) {
        yield put(getManagerAttestationInboxFail(extractErrorMessage(error, "Erreur chargement inbox manager attestations")));
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* managerAttestationDecisionSaga(action) {
    // payload: { id, approved, comment }
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");

    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/attestations/manager/requests/${id}/decision`;

    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: { approved, comment }, headers: { uid } });
        yield put(managerAttestationDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], { icon: "success", title: "", text: "Décision envoyée", timer: 1400, showConfirmButton: false });
        yield put({ type: GET_MANAGER_ATTESTATION_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision manager");
        yield put(managerAttestationDecisionFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* getAdminAttestationInboxSaga() {
    const url = `${API_BASE_URL}/api/attestations/admin/inbox`;
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");


    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAdminAttestationInboxSuccess(resp.data || []));
    } catch (error) {
        yield put(getAdminAttestationInboxFail(extractErrorMessage(error, "Erreur chargement inbox RH attestations")));
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function printBlob(data) {
    const blob = data instanceof Blob ? data : new Blob([data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const printFrame = document.createElement("iframe");
    printFrame.style.display = "none";
    printFrame.src = url;
    printFrame.onload = () => {
        printFrame.contentWindow?.print();
        setTimeout(() => {
            printFrame.remove();
            window.URL.revokeObjectURL(url);
        }, 1000);
    };
    document.body.appendChild(printFrame);
}

export function* getAdminAttestationHistorySaga() {
    const url = `${API_BASE_URL}/api/attestations/admin/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAdminAttestationHistorySuccess(resp.data || []));
    } catch (error) {
        yield put(getAdminAttestationHistoryFail(extractErrorMessage(error, "Erreur chargement historique RH attestations")));
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* adminAttestationDecisionSaga(action) {
    // payload: { id, approved, comment }
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");

    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/attestations/admin/requests/${id}/decision`;

    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: { approved, comment }, headers: { uid } });
        yield put(adminAttestationDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], { icon: "success", title: "", text: "Décision RH envoyée", timer: 1400, showConfirmButton: false });
        yield put({ type: GET_ADMIN_ATTESTATION_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision RH");
        yield put(adminAttestationDecisionFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

// ===================== DOWNLOAD =====================
export function* downloadAttestationPdfSaga(action) {
    // payload: { attestationId, filename? }
    const token = sessionStorage.getItem("token");
       const uid = sessionStorage.getItem("uid");

    const { attestationId, filename, print = false } = action.payload || {};

    const url = `${API_BASE_URL}/api/attestations/${attestationId}/download-pdf`;

    yield put(setAttestationsLoading(true));
    try {
        // const resp = yield call(getRequest, {
        //     url,
        //     token,
        //     headers: { uid },
        //     responseType: "blob",
        // });
        const resp = yield call(getRequestForPdf, {
            url,
            token,
            headers: { uid },
            responseType: "arraybuffer",
        });

        const blob = new Blob([resp.data], { type: "application/pdf" });
        if (print) printBlob(blob);
        else saveBlob(blob, filename || `attestation_${attestationId}.pdf`);
        yield put(downloadAttestationPdfSuccess(true));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur téléchargement PDF");
        yield put(downloadAttestationPdfFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

export function* downloadAttestationRequestPdfSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { requestId, filename, print = false } = action.payload || {};
    const url = `${API_BASE_URL}/api/attestations/requests/${requestId}/download-pdf`;

    yield put(setAttestationsLoading(true));
    try {
        const resp = yield call(getRequestForPdf, {
            url,
            token,
            headers: { uid },
            responseType: "arraybuffer", // ✅ IMPORTANT
        });

        const blob = new Blob([resp.data], { type: "application/pdf" });
        if (print) printBlob(blob);
        else saveBlob(blob, filename || `attestation_request_${requestId}.pdf`);

        yield put(downloadAttestationRequestPdfSuccess(true));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur téléchargement PDF");
        yield put(downloadAttestationRequestPdfFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setAttestationsLoading(false));
    }
}

// ===================== WATCHERS =====================
